import Kanban from '../../components/menu/kanban';

export default Kanban;